import { useDriveThumbnail, type VaultLinkRow } from '@/data/vault';
import { desktopBridge } from '@/lib/bridge';
import { linkThumbnails } from './model';

/** A link's thumbnails, best first (see linkThumbnails). */
export function useLinkThumbnails(link: VaultLinkRow): string[] {
  const drive = useDriveThumbnail(link);
  return linkThumbnails(link, { driveThumbnail: drive.data ?? null, inBrowser: !desktopBridge() });
}
